/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { directorRoleIds } from '../../../utils/eventConstants';
import { ManageAccountRoleIDs } from '../../../utils/eventDeskConstants';
import * as drawEditActions from '../../../actions/draw-edit-actions';
import ColumnHeader from '../../../components/ColumnHeader';
import styles from '../drawEdit.scss';
import Img from '../../../components/Img';
import CourtDeskSidePanel from '../CourtSchedular/CourtDeskSidePanel';
import courtSchedularStyles from '../CourtSchedular/courtSchedular.scss';
import { PlayerSearch } from '../../../components/Form';
import BackgroundImage from '../../../components/BackgroundImage';
import AvatarV2 from '../../../components/cards/PlayerCard/ListViewComponents/AvatarV2';
import config from '../../../../config';

const ManageAccountsTab = (props) => {
    const { eventId, sportTypeId } = props;
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [submittingDirector, setSubmittingDirector] = useState(false);
    const [showPanel, setShowPanel] = useState(false);
    const [directors, setDirectors] = useState([]);
    const [memberSelectedForAdd, setMemberSelectedForAdd] = useState();
    const [memberSelectedForAddRole, setMemberSelectedForAddRole] = useState();
    const imageBaseUrl = config.alwaysUseProxy ? '/api/v1/player/' : '/v1/player/';

    const getDirectors = async () => {
      setLoading(true);
      const response = await dispatch(drawEditActions.getEventDirectors(eventId));
      setDirectors(response);
      setLoading(false);
    };

    useEffect(() => {
      getDirectors();
    }, []);

    const handleDeleteIndividual = async (memberId) => {
        setLoading(true);
        const response = await dispatch(drawEditActions.deleteEventDirector(eventId, memberId));
        if (response) {
            const updatedList = directors.filter((director) => director.memberId !== memberId);
            setDirectors(updatedList);
        }
        setLoading(false);
    };
  const handleChangeRole = (event) => {
      setMemberSelectedForAddRole(parseInt(event.target.value));
    };
    const beginClosePanel = () => {
        setShowPanel(false);
    };
    const onPanelClose = () => {
        resetSelections();
    };
    const handleAddDirector = async () => {
      setLoading(true);
      setSubmittingDirector(true);
      const payload = {
        memberId: memberSelectedForAdd.memberId,
        eventDirectorRoleId: memberSelectedForAddRole,
      };
      let action;
      if (memberSelectedForAddRole === directorRoleIds.ADMIN) {
        action = drawEditActions.addEventAdmin(eventId, payload);
      }
      if (memberSelectedForAddRole === directorRoleIds.VOLUNTEER) {
        action = drawEditActions.addEventVolunteer(eventId, payload);
      }
      const response = await dispatch(action);
      resetSelections();
      setShowPanel(false);
      if (response) {
        getDirectors();
      } else {
        setLoading(false);
      }
    };
    const resetSelections = () => {
      setMemberSelectedForAdd(undefined);
      setMemberSelectedForAddRole(undefined);
      setSubmittingDirector(false);
    };
    return (
        <div className={`${styles.section} bg-transparent main-content manage-accounts`}>

            <div className={`container mt32 bg-transparent`}>
                <div className="d-flex jsb aic pl24 mb32">
                    <div className="text-highlight3 text-dark" data-testid="manage-accounts.title">MANAGE ACCOUNTS</div>
                    <a className="text-small fw300 d-flex aic text-medium-blue pointer" onClick={() => setShowPanel(true)} data-testid="manage-accounts.add-btn">
                        <Img className="close-icon pr4" src={`/img/v3/icons/icon-24px-settings-blue.svg`} />
                        Add an account
                    </a>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="all-players-header fs14 fw600 d-flex aic">
                            <div className="row flex-1">
                                <div className={`col-md-11`}>
                                    <div className="row">
                                        <div className={'col-md-4'}>
                                            <ColumnHeader
                                                columnName="Name"
                                                className="cursor-unset"
                                                data-testid="manage-accounts.header-name"
                                            />
                                        </div>

                                        <div className="col-md-8">
                                            <ColumnHeader columnName="Role" className="cursor-unset" data-testid="manage-accounts.header-role" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1 p0" />
                            </div>
                        </div>
                        <div className={`all-players-list p-rel ${loading && 'opacity05'}`}>
                            {directors.length > 0 && (
                                <div>
                                    {directors?.map((director) => {
                                          return (
                                              <div className={`item ${styles.allPlayersItem} check-in-item`} key={director.memberId} data-testid={`manage-accounts.director-${director.memberId}`}>
                                                  <div className="row flex-1 text-dark">
                                                      <div className={`col-md-11`}>
                                                          <div className="row">
                                                              <a className={'col-md-4 name d-flex aic'} href={`/profiles/${director.playerId}`} target="_blank" rel="noopener noreferrer" data-testid={`manage-accounts.director-${director.memberId}.name`}>
                                                                  <AvatarV2
                                                                      playerImages={director.playerProfileImages}
                                                                      player={director}
                                                                      className={styles.avatar}
                                                                  />
                                                                  {director.firstName} {director.lastName}
                                                              </a>

                                                              <div className="col-md-8 fw300 d-flex aic" data-testid={`manage-accounts.director-${director.memberId}.role`}>
                                                                  {ManageAccountRoleIDs[director.eventDirectorRoleId]}
                                                              </div>
                                                          </div>
                                                      </div>
                                                      <div className="col-md-1 p0 d-flex aic jce">
                                                          <Img src={'/img/v3/icons/icon-trash-red.svg'} className="cursor-pointer mr16" onClick={() => handleDeleteIndividual(director.memberId)} data-testid={`manage-accounts.director-${director.memberId}.delete-btn`} />
                                                      </div>
                                                  </div>
                                              </div>
                                          );
                                        })}
                                </div>
                            )}
                            {loading && directors.length < 1 && (
                                <div className="row divisions-big">
                                    <div className="col" data-testid="manage-accounts.loading">
                                        Loading individuals...
                                    </div>
                                </div>
                            )}
                            {!loading && !directors?.length && (
                                <div className="row divisions-big">
                                    <div className="col" data-testid="manage-accounts.empty-msg">
                                        No individuals were found.
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <CourtDeskSidePanel
                allowCloseOnClickOutside
                closeSideBar={beginClosePanel}
                isVisible={showPanel}
                onClose={onPanelClose}
            >
                    <div className={courtSchedularStyles.header} data-testid="manage-accounts.panel.title">
                        Add an account
                    </div>
                    <div className={`${courtSchedularStyles.content} content-wrapper`}>
                        <div className="search-wrapper">
                            {!memberSelectedForAdd && (
                                <PlayerSearch
                                    className="form-control"
                                    placeholder="Search by name"
                                    showInvitePlayer={false}
                                    showDemoPlayers={false}
                                    handlePlayerSelect={(player) => {
                                      setMemberSelectedForAdd(player);
                                    }}
                                    searchMembersOnly={true}
                                    excludeProPlayers={true}
                                    closeAfterSelect={true}
                                    sportTypeId={sportTypeId}
                                />
                              )}
                        </div>
                        {memberSelectedForAdd && (
                            <div>
                                <div className="player-profile">
                                    <BackgroundImage
                                        baseUrl={imageBaseUrl}
                                        defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                        images={memberSelectedForAdd.playerProfileImages}
                                        imageType={'icon'}
                                        parentStylesClass="player-profile-picture"
                                    />
                                    <div className="player-profile-name text-dark" data-testid="manage-accounts.panel.selected-name">{memberSelectedForAdd.firstName} {memberSelectedForAdd.lastName}</div>

                                </div>
                                <div>
                                    <div className="text-small text-xtra-dark fw500" data-testid="manage-accounts.panel.access-level-label">ACCESS LEVEL</div>
                                    <div className="mt16">
                                        <label className="role-option fw300" data-testid="manage-accounts.panel.admin-role">
                                            <input
                                                type="radio"
                                                name="role"
                                                value={1}
                                                checked={memberSelectedForAddRole === directorRoleIds.ADMIN}
                                                onChange={handleChangeRole}
                                            />
                                            Admin
                                        </label>
                                        <label className="role-option fw300" data-testid="manage-accounts.panel.volunteer-role">
                                            <input
                                                type="radio"
                                                name="role"
                                                value={3}
                                                checked={memberSelectedForAddRole === directorRoleIds.VOLUNTEER}
                                                onChange={handleChangeRole}
                                            />
                                            Volunteer
                                        </label>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className={`${courtSchedularStyles.footer} d-flex`}>
                        <button
                            className={'btn btn-default mr8 flex-1'}
                            type="button"
                            onClick={beginClosePanel}
                            data-testid="manage-accounts.panel.cancel-btn"
                        >
                        Cancel
                        </button>
                        <button
                            className={`btn btn-primary flex-1`}
                            onClick={handleAddDirector}
                            type="button"
                            disabled={submittingDirector}
                            data-testid="manage-accounts.panel.add-btn"
                        >
                        Add
                        </button>
                    </div>
            </CourtDeskSidePanel>
        </div>
    );
};
ManageAccountsTab.propTypes = {
    eventId: PropTypes.string,
    sportTypeId: PropTypes.string.isRequired,
};
ManageAccountsTab.defaultProps = {
    eventId: '',
};
export default ManageAccountsTab;
